<template>
    <svg viewBox="0 0 32 7" width="28" height="7" xmlns="http://www.w3.org/2000/svg">
        <g fill="#FFF" fill-rule="evenodd">
            <circle cx="3" cy="3.7" r="3" />
            <circle cx="16" cy="3.7" r="3" />
            <circle cx="29" cy="3.7" r="3" />
        </g>
    </svg>
</template>

<script>
export default {
    name: 'IconReportDots',
};
</script>
